export default () => [


    // {
    //     title: app.$t("photos.title"),
    //     mdi: "mdiImageOutline",
    //     link: "/gallery",
    //     free: true,
    // },

    // {
    //     title: app.$t("menu.animations"),
    //     mdi: "mdiMovieOpenPlayOutline",
    //     link: "/animations",
    // },

    // {
    //     title: app.$t("menu.calculator"),
    //     mdi: "mdiCalculatorVariantOutline",
    //     link: "/calculator",
    //     free: true,
    // },



    {
        title: app.$t("menu.pricelist"),
        icon: "coin",
        link: "/pricelist",
    },

    {
        title: app.$t("menu.history"),
        icon: "folder_clock_outline",
        link: "/history",
    },

    {
        title: app.$t("menu.settings"),
        icon: "cog_outline",
        link: "/settings",
    },


    {
        title: "Tutorials",
        mdi: "mdiHumanMaleBoard",
        link: "/tutorials",
    },




    {
        title: "F.A.Q.",
        mdi: "mdiCommentProcessingOutline",
        link: "/faq",
    },



    {
        title: app.$t("menu.support"),
        icon: "help",
        link: "/support",
    },




    // {
    //     title: app.$t("menu.subscriptions"),
    //     icon: "credit_card_outline",
    //     // link: "/addons",
    //     callback: () => {
    //         app.$bus.$emit('openAppDialog','premium');
    //     }
    // },
    // {
    //     title: app.$t("support.send_feedback"),
    //     icon: "comment_processing_outline",
    //     link: "/feedback",
    // },
];
